export const WHATSAPP = "50582579338";
export const PHONE = "+50582579338";
export const EMAIL = "marketing@eltimonsanjuandelsur.net";
export const ADDRESS = "Del BAC media cuadra oeste, calle costera, frente a la playa, San Juan del Sur, Nicaragua";
export const FACEBOOK = "https://www.facebook.com/eltimonsjs";
export const INSTAGRAM = "https://www.instagram.com/eltimonsanjuandelsur";
export const GOOGLE_MAPS = "https://www.google.com/maps/place/Restaurante+El+Tim%C3%B3n+San+Juan+del+Sur/data=!4m2!3m1!1s0x8f75b443bbcadd5d:0x3c5999dcdf1becff";
export const GOOGLE_DIRECTIONS = "https://www.google.com/maps/dir/?api=1&destination=Restaurante+El+Tim%C3%B3n+San+Juan+del+Sur%2C+Nicaragua";
export const MAPS_EMBED = "https://www.google.com/maps?q=Restaurante+El+Tim%C3%B3n+San+Juan+del+Sur+Nicaragua&output=embed";
export const LOGO = "/logo.png";

export function waLink(text) {
  return `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(text)}`;
}

export function money(v, currency = "C$") {
  return `${currency}${Number(v).toLocaleString("es-NI", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}
